
import { APP_INITIALIZER, Inject, Injectable, DOCUMENT } from "@angular/core";
import { TrackingService, TrackerType, TOKENS as TOKENS_ANALYTICS,  } from "@trustedshops/tswp-core-analytics";
import { BootstrapperBase } from "@trustedshops/tswp-core-common";
import { UserCentricsConsent } from "../core/user-centrics-consent";
import { ENVIRONMENT, Environment } from "../models/environment.type";

@Injectable()
export class MsClarityBootstrapper extends UserCentricsConsent implements BootstrapperBase {
  public constructor(
    @Inject(TOKENS_ANALYTICS.TrackingService) private readonly _trackingService: TrackingService,
    @Inject(ENVIRONMENT) private readonly _environment: Environment,
    @Inject(DOCUMENT) readonly _document: Document,
  ) {
    super(_document);
  }

  public async initialize(): Promise<void> {
    const hasMSClarityConsent = await this.userConsentObtained('Microsoft Clarity');
    this.ensureMSClarityTrackerRegistered(hasMSClarityConsent);
  }
  private ensureMSClarityTrackerRegistered(hasMSClarityConsent: boolean): void {
    if (this._trackingService.trackers.includes(this._environment.tracking.msClarity.projectId)) {
      return;
    }

    if (hasMSClarityConsent) {
      this._trackingService
        .registerTracker(TrackerType.MSClarityAnalytics, {
          projectId: this._environment.tracking.msClarity.projectId,
        });
    }
  }
}
export const MsClarityInitializer = [
  MsClarityBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: MsClarityBootstrapper) => {
      return () => initializer.initialize();
    },
    deps: [MsClarityBootstrapper]
  }
];
